var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trackline-view"},[_c('div',{staticClass:"total-orders"},[_vm._v("{$t('total_active_orders')}}: "+_vm._s(_vm.totalActiveOrders))]),_c('Trackline',{attrs:{"tab":"tracklineView"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }